import { render, staticRenderFns } from "./InvoiceListField.vue?vue&type=template&id=5b99d3b4"
import script from "./InvoiceListField.vue?vue&type=script&lang=js"
export * from "./InvoiceListField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports